/**
 * Header content for owner role — replaces world clocks with monthly +
 * yearly trip stats. Data is fetched by the parent (TopHeader) so this
 * component stays pure presentation.
 */

import React from "react";
import { useTranslation } from "react-i18next";

export default function OwnerStats({ stats }) {
  const { t } = useTranslation();

  if (!stats) {
    return (
      <div className="w-4 h-4 border-2 border-slate-700 border-t-slate-400 rounded-full animate-spin" />
    );
  }

  // Pending/confirmed counters were removed (operational noise for an owner);
  // the freed space lets each remaining counter carry its full phrase instead
  // of the cramped "Viajes/Mes" abbreviation. All four are flown-trip/hours
  // figures attributed to THIS owner's trips (see GET /owner/trip-stats).
  const items = [
    { value: stats.completed, label: t("ownerStats.doneMonth") },
    { value: stats.hoursFlown ?? "—", label: t("ownerStats.hoursMonth") },
    { value: stats.yearlyTrips, label: t("ownerStats.tripsYear"), startsYearGroup: true },
    { value: stats.yearlyHours ?? "—", label: t("ownerStats.hoursYear") },
  ];

  return (
    <div className="flex items-center gap-2 sm:gap-3">
      {items.map((it, i) => (
        <React.Fragment key={it.label}>
          {it.startsYearGroup ? (
            <span className="w-px h-4 bg-slate-700 mx-0.5 self-center" />
          ) : (
            i > 0 && <span className="text-slate-700 text-xs">·</span>
          )}
          <div className="flex items-baseline gap-1.5">
            <span className="font-mono font-bold text-slate-200 tabular-nums text-sm sm:text-base">
              {it.value}
            </span>
            <span className="text-[10px] sm:text-xs text-slate-400 tracking-wide whitespace-nowrap">
              {it.label}
            </span>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
}
